import { useEffect, useState } from "react";
import { Context } from "./Context";
import axios from "axios";

export default function ContextProvider({ children }) {

  const [dark, setDark] = useState(
    localStorage.getItem("theme") === "dark"
  );

  const [auth, setAuth] = useState(null);
  const [user, setUser] = useState(null);
  const [alreadyBooked, setAlreadyBooked] = useState([]);
  const [myPayments, setMyPayments] = useState([]);

  //////////////////////////////////////////////////////
  // THEME EFFECT (ONLY FOR THEME)
  //////////////////////////////////////////////////////
  useEffect(() => {
    const html = document.documentElement;

    if (dark) {
      html.classList.add("dark");
      localStorage.setItem("theme", "dark");
    } else {
      html.classList.remove("dark");
      localStorage.setItem("theme", "light");
    }
  }, [dark]);

  //////////////////////////////////////////////////////
  // LOAD AUTH ON APP START
  //////////////////////////////////////////////////////
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) setAuth(token);
  }, []);

  //////////////////////////////////////////////////////
  // FETCH DATA WHEN AUTH CHANGES
  //////////////////////////////////////////////////////
  useEffect(() => {
    if (auth) {
      fetchBookedSlots();
      fetchMyPayments();
    }
  }, [auth]);

  //////////////////////////////////////////////////////
  // FETCH BOOKED SLOTS
  //////////////////////////////////////////////////////
  const fetchBookedSlots = async () => {
    try {
      const res = await axios.get(
        "https://api.clinicalaiassistance.com/api/payment/getBookedSlots"
      );

      if (res.data.success) {
        setAlreadyBooked(res.data.slots);
      }
    } catch (error) {
      console.error("Error fetching booked slots:", error);
    }
  };

  //////////////////////////////////////////////////////
  // FETCH MY PAYMENTS
  //////////////////////////////////////////////////////
  const fetchMyPayments = async () => {
    try {
      const token = localStorage.getItem("token");

      const res = await axios.get(
        "https://api.clinicalaiassistance.com/api/payment/getMyPayments",
        { headers: { Auth: token } }
      );

      if (res.data.success) {
        setMyPayments(res.data.payments);
      }
    } catch (error) {
      console.error("Error fetching my payments:", error);
    }
  };

  //////////////////////////////////////////////////////
  // CONTEXT VALUE
  //////////////////////////////////////////////////////
  return (
    <Context.Provider
      value={{
        dark,
        setDark,
        auth,
        setAuth,
        user,
        setUser,
        alreadyBooked,
        fetchBookedSlots,
        myPayments,
        fetchMyPayments,
      }}
    >
      {children}
    </Context.Provider>
  );
}
